<template>
  <div class="myZoneContainer" @scroll="getScroll($event)">
    <div class="waterfallList" v-if="contentList1.length !== 0">
      <div class="Inlist" v-for="(item, index) in contentList1" :key="index">
        <div class="numIcon">
          <div class="numType">{{ item.picturecount }}</div>
        </div>
        <img
          :src="item.pictureurl"
          alt=""
          class="contentPic"
          @click="goXiangqing(item.id)"
        />
        <div class="word">
          <div class="listContent" @click="goXiangqing(item.id)">
            {{ item.content }}
          </div>
          <div class="hudong">
            <div class="date">{{ item.createtime }}</div>
            <div
              class="dianzan"
              @click="
                dianzan(
                  item.id,
                  item.isFabulous,
                  !item.hasOwnProperty('isFabulous'),
                  index
                )
              "
            >
              <img
                src="../assets/images/dianzan1.png"
                alt=""
                v-show="
                  item.isFabulous == 0 || !item.hasOwnProperty('isFabulous')
                "
              />
              <img
                src="../assets/images/dianzan2.png"
                alt=""
                v-show="item.isFabulous == 1"
              />
              <div class="dianzanNum">{{ item.fabulouscount | filterNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nocontent" v-if="contentList1.length == 0">
      <div class="nocontentImg">
        <img src="../assets/images/noAddr.png" alt="" />
      </div>
      <div class="word">暂无内容</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { setTime } from "../utils/setTimeStamp";
import { Swipe, SwipeItem } from "vant";
import { Tabbar, TabbarItem } from "vant";
import { Tab, Tabs } from "vant";
import { Icon } from "vant";
import { Dialog } from "vant";
import { List } from "vant";

Vue.use(List);

// 全局注册
Vue.use(Dialog);

Vue.use(Icon);

Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.use(Swipe);
Vue.use(SwipeItem);
import { doRem } from "../utils/setrem";
import qs from "qs";
export default {
  mounted() {
    this.getHudong2List();

    this.getHeight();
  },
  data() {
    return {
      isLoading: false,
      isFinished: false,
      noDianzan: true,
      hasDianzan: false,
      contentList: [],
      contentList1: [],
      newWord: "",
      currentPage: 1,
      pageLimit: 8,
    };
  },
  methods: {
    hudong2Like(shiwuName) {
      this.contentList1 = [];
      let list = this.contentList.filter((v) => {
        if (v.content.includes(shiwuName)) {
          return v;
        }
      });

      this.contentList1 = list;
    },
    goXiangqing(id) {
      this.$router.push({
        name: "FabuXiangqing",
        query: {
          id,
        },
      });
    },
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".myZoneContainer").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".myZoneContainer").style.height = a - b + "px";
    },

    getScroll(event) {
      // 滚动条距离底部的距离scrollBottom

      let scrollBottom =
        event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight;

      if (
        scrollBottom < 200 &&
        this.isLoading == false &&
        this.isFinished == false
      ) {
        this.getHudong2List();
      }
    },
    onLoad() {
      // this.getcontentList()
      // this.getHudongList();
      // console.log(1);
      // console.log(this.loading);
    },
    dianzan(id, isFabulous, isDianzan, index) {
      console.log(this.contentList1[index]);
      if (isFabulous == 0 || isDianzan) {
        let params = qs.stringify({
          interactionid: id,
        });
        this.$axios
          .post("appinteraction/user/appInteraction/saveFabulous", params)
          .then((res) => {
            console.log(res);
            if (res.data.result !== 1) {
              Dialog.alert({
                message: res.data.reason,
              }).then(() => {});
              return;
            }
            if (res.data.result === 1) {
              this.contentList1[index].isFabulous = 1;
              this.contentList1[index].fabulouscount += 1;
              this.$toast("点赞成功");
              return;
            }
          })
          .catch((err) => {
            console.error(err);
            Dialog.alert({
              message: "接口调用失败",
            }).then(() => {});
            return;
          });
      }
      if (isFabulous == 1) {
        let params = qs.stringify({
          interactionid: id,
        });

        this.$axios
          .post("appinteraction/user/appInteraction/delFabulous", params)
          .then((res) => {
            console.log(res);
            if (res.data.result !== 1) {
              Dialog.alert({
                message: res.data.reason,
              }).then(() => {});
              return;
            }
            if (res.data.result === 1) {
              this.contentList1[index].isFabulous = 0;
              this.contentList1[index].fabulouscount -= 1;
              this.$toast("取消点赞");
              return;
            }
          })
          .catch((err) => {
            console.error(err);
            Dialog.alert({
              message: "接口调用失败",
            }).then(() => {});
            return;
          });
      }
    },
    getHudong2List() {
      this.isLoading = true;
      let params = qs.stringify({
        type: 1,
        pageIndex: this.currentPage,
        pageSize: this.pageLimit,
      });

      this.$axios
        .post("appinteraction/user/appInteraction/getPageList", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            });
            return;
          }
          if (res.data.result === 1) {
            if (res.data.pageList.length == 0) {
              this.isFinished = true;
              return;
            }

            res.data.pageList.forEach((item) => {
              item.createtime = setTime(Number(item.createtime));
              if (item.content.length > 19) {
                item.content = item.content.substring(0, 19) + "...";
              }
              this.contentList.push(item);
              this.contentList1 = JSON.parse(JSON.stringify(this.contentList));
              this.contentList1 = this.reOrder(this.contentList1, 2);
            });
          }
          this.isLoading = false;
          this.currentPage++;
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    reOrder(arr, columns) {
      const cols = columns;
      const out = [];
      let col = 0;
      while (col < cols) {
        for (let i = 0; i < arr.length; i += cols) {
          let _val = arr[i + col];
          if (_val !== undefined) out.push(_val);
        }
        col++;
      }
      return out;
    },
  },
  filters: {
    filterNum: function (value) {
      if (Number(value) > 99) {
        return (value = "99+");
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.myZoneContainer {
  background: #fff;
  padding: 2rem;
  border-radius: 1.5625rem;
  margin-bottom: 25rem;
  overflow: auto;
}

.waterfallList {
  -moz-column-count: 2; /* Firefox */
  -webkit-column-count: 2; /* Safari 和 Chrome */
  column-count: 2;
  -moz-column-gap: 1rem;
  -webkit-column-gap: 1rem;
  column-gap: 2.125rem;

  margin-bottom: 12.5rem;
}

.Inlist {
  margin: 0 0 2rem 0;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
  position: relative;
  padding: 0;
  line-height: unset;
  font-size: 1.75rem;
  color: #19212a;
  overflow: initial;

  .numIcon {
    position: absolute;
    width: 2.75rem;
    height: 2.75rem;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 25rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 1.375rem;
    right: 1.625rem;
    font-size: 1.5rem;
  }
}

.contentPic {
  width: 100%;
  margin-bottom: 0.625rem;
  border-radius: 1rem;
}

.word {
  .listContent {
    padding: 0 0.375rem;
    font-size: 1.75rem;
    color: #19212a;
    letter-spacing: 1px;
    line-height: 2.625rem;
  }

  .hudong {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem;

    margin-top: 1.25rem;
    color: #878787;
    .date {
      font-size: 1.5rem;
      white-space: nowrap;
    }
    .pinlun {
      display: flex;
      align-items: center;
      margin-left: 7rem;

      img {
        width: 2.125rem;
      }
    }
    .dianzan {
      display: flex;
      align-items: center;
      margin-left: 2rem;
      img {
        width: 2.125rem;
      }
      .dianzanNum {
        font-size: 1.5rem;
      }
    }
  }
}
.nocontent {
  padding-top: 20.625rem;
  .nocontentImg {
    display: flex;
    justify-content: center;
    img {
      width: 21.25rem;
      height: 14.25rem;
    }
  }
  .word {
    color: #19212a;
    font-size: 2.125rem;
    margin-top: 3rem;
    text-align: center;
    font-weight: 400;
  }
}
</style>
<style lang="scss" scoped >
</style>